import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProposalPage from './pages/ProposalPage';
import DemoLanding from './pages/DemoLanding';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/demo" element={<DemoLanding />} />
        <Route path="/proposal/:dealId" element={<ProposalPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
